import type { EvidenceItem, EvidenceSource } from "@/types/content";

function SourceBlock({ source, side }: { source: EvidenceSource; side: string }) {
  return (
    <div className="flex-1 rounded-md border border-background-200 bg-background-50 p-4">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] font-medium tracking-wide text-foreground-500">
          {side}
        </span>
        <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
          {source.level}
        </span>
      </div>
      <p className="mt-2 font-heading text-sm font-semibold text-foreground-950">
        {source.name}
      </p>
      <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
        {source.detail}
      </p>
    </div>
  );
}

export default function EvidenceCard({ item }: { item: EvidenceItem }) {
  return (
    <article className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-price-tag-3-line text-xs"></i>
          </span>
          {item.category}
        </span>
        <span className="whitespace-nowrap text-xs text-foreground-500">
          判定：<span className="font-medium text-foreground-800">{item.verdict}</span>
        </span>
      </div>

      <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950">
        待验证说法：{item.claim}
      </h3>

      <div className="mt-4 flex flex-col gap-3 lg:flex-row">
        <SourceBlock source={item.sourceA} side="来源 A" />
        <SourceBlock source={item.sourceB} side="来源 B" />
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-foreground-600">
          <span>可信度评估</span>
          <span className="font-medium text-foreground-900">{item.confidence}%</span>
        </div>
        <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
          <div
            className="h-full rounded-full bg-primary-500"
            style={{ width: `${item.confidence}%` }}
          ></div>
        </div>
      </div>

      <p className="mt-4 rounded-md bg-background-200/60 px-3 py-2.5 text-xs leading-relaxed text-foreground-700">
        <span className="font-medium text-foreground-900">对照结论：</span>
        {item.note}
      </p>
    </article>
  );
}